import { all_routes } from "../../../feature-module/router/all_routes";


export const header = [
  {
    tittle: "More",
    showAsTab: false,
    separateRoute: false,
    base: "pages",
    menu: [
      // {
      //   menuValue: "About Us",
      //   route: all_routes.aboutUs,
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   subMenus: [],
      // },
      {
        menuValue: "FAQ",
        route: all_routes.faq,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      // {
      //   menuValue: "Gallery",
      //   route: all_routes.gallery,
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   subMenus: [],
      // },
      // {
      //   menuValue: "Our Team",
      //   route: all_routes.ourTeam,
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   subMenus: [],
      // },
      // {
      //   menuValue: "Testimonials",
      //   route: all_routes.testimonial,
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   subMenus: [],
      // },
      {
        menuValue: "Terms & Conditions",
        route: all_routes.termsConditions,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      {
        menuValue: "Privacy Policy",
        route: all_routes.privacyPolicy,
        hasSubRoute: false,
        showSubRoute: false,
        subMenus: [],
      },
      // {
      //   menuValue: "Blog",
      //   route: all_routes.blogGrid,
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   subMenus: [],
      // },
      // {
      //   menuValue: "Contact",
      //   route: all_routes.contactUs,
      //   hasSubRoute: false,
      //   showSubRoute: false,
      //   subMenus: [],
      // },
    ],
  },
  // {
  //   tittle: "My Account",
  //   base: "user",
  //   showAsTab: false,
  //   separateRoute: false,
  //   menu:  [
  //         {
  //           menuValue: "Dashboard",
  //           route: all_routes.userDashboard,
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           subMenus: [],
  //         },
  //         {
  //           menuValue: "My Bookings",
  //           route: all_routes.userBookings,
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           subMenus: [],
  //         },
  //         {
  //           menuValue: "Reviews",
  //           route: all_routes.userReviews,
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           subMenus: [],
  //         },
  //         {
  //           menuValue: "Wishlist",
  //           route: all_routes.userWishlist,
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           subMenus: [],
  //         },
  //         {
  //           menuValue: "Payments",
  //           route: all_routes.userPayment,
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           subMenus: [],
  //         },
  //         {
  //           menuValue: "Settings",
  //           route: all_routes.userSettings,
  //           hasSubRoute: false,
  //           showSubRoute: false,
  //           subMenus: [],
  //         }
  //       ],
  // },
];
